import React, { useEffect, useState } from 'react';
import CenterSpinner from '../../components/CenterSpinner';
import { Label } from 'reactstrap';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import {
  LeaveFilterType,
  LocationFilterInitialState,
  LoggedUserType,
  PaginationType,
  UserType,
} from '../../utils/Types';
import {
  API_STATUS,
  DEFAULT_PAGE_SIZE,
  LEAVE_PAGE_TYPE,
} from '../../utils/Constant';
import LeavesFilter from '../../filters/LeavesFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  attendanceSelector,
  clearLeaveDetails,
  fetchLeavesHistoryList,
  fetchLeavesPendingList,
} from '../../features/attendanceSlice';
import LeaveModal from '../modals/LeaveModal';
import { loginSelector } from '../../features/loginSlice';
import { locationFilterSelector } from '../../features/locationFilterSlice';
import { getLeaveListParams, requestCities } from './ViewAttendeesPageHelper';
import { useLoader } from '../../loader/LoaderProvider';

interface IViewLeavesPageProps {
  type: string | null;
  columnsHeder: any[];
  title: string;
}

const ViewLeavesPage: React.FunctionComponent<IViewLeavesPageProps> = ({
  type,
  columnsHeder,
  title,
}) => {
  const { showLoader, setShowLoader } = useLoader();
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState<boolean>(false);
  const [selectedDetails, setSelectedDetails] = useState<any>();
  const [selectedFilter, setSelectedFilter] = useState<LeaveFilterType>();
  const [leaveHistoryListData, setLeaveHistoryListData] = useState<any>([]);
  const dispatch = useAppDispatch();

  const leaveDataList: any =
    useAppSelector(attendanceSelector).leaveHistoryData.leaveList;
  const pagination: PaginationType =
    useAppSelector(attendanceSelector).leaveHistoryData.pagination;
  const apiStatus = useAppSelector(attendanceSelector).apiProgressStatus;
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const locationData: LocationFilterInitialState = useAppSelector(
    locationFilterSelector
  );

  const fetchLeaves = () => {
    const data = getLeaveListParams(
      currentPage,
      pageSize,
      type,
      user,
      userDetails,
      selectedFilter
    );
    if (type === LEAVE_PAGE_TYPE.APPROVE_LEAVE) {
      dispatch(fetchLeavesPendingList(data));
    } else {
      dispatch(fetchLeavesHistoryList(data));
    }
  };

  useEffect(() => {
    if (apiStatus && apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  useEffect(() => {
    fetchLeaves();
  }, [currentPage, pageSize, selectedFilter, user, userDetails]);

  useEffect(() => {
    if (!showLoader) setLeaveHistoryListData(leaveDataList);
    return () => {
      setLeaveHistoryListData([]);
    };
  }, [leaveDataList, showLoader]);
  useEffect(() => {
    if (type === LEAVE_PAGE_TYPE.APPROVE_LEAVE) {
      requestCities(leaveDataList, locationData, dispatch);
    }
  }, [leaveDataList]);
  return (
    <div className="ml-4">
      <Label className="text-heading">{title}</Label>
      <LeavesFilter onApplyFilters={setSelectedFilter} type={type} />
      <div className="mt-4  mt-md-4">
        <KTable
          data={leaveHistoryListData}
          columnHeader={columnsHeder}
          onAction={(data: any) => {
            setSelectedDetails(data);
            dispatch(clearLeaveDetails());
            setIsApproveModalOpen(true);
          }}
          tableParentClass="table-parent-view-attendance"
          isLoading={showLoader}
          locationData={locationData}
        />
        {leaveDataList && !showLoader && leaveDataList.length > 0 && (
          <KPagination
            currentPage={pagination?.currentPage}
            pageSize={pagination?.pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination?.fromItem}
            toItem={pagination?.toItem}
            totalItems={pagination?.totalItems}
          />
        )}
      </div>
      {isApproveModalOpen && (
        <LeaveModal
          isOpen={isApproveModalOpen}
          toggleApproveModal={() => {
            setIsApproveModalOpen(false);
            setSelectedDetails(null);
            fetchLeaves();
          }}
          selectedDetails={selectedDetails}
          type={type}
        />
      )}
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
    </div>
  );
};

export default ViewLeavesPage;
